import { legacyLogicalPropertiesTransformer, StyleProvider } from '@ant-design/cssinjs';
import { Alert, Button } from 'antd';
import Bowser from 'bowser';
import React from 'react';
export var SuperRootContainerAlerter = function SuperRootContainerAlerter(properties) {
  var browserInformation = Bowser.getParser(window.navigator.userAgent);
  return browserInformation.satisfies({
    chrome: '>=89',
    edge: '>=89'
  }) ? properties.children : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    showIcon: true,
    closable: true,
    type: "warning",
    message: "\u672C\u7F51\u7AD9\u63D0\u4F9B\u7684\u90E8\u5206\u670D\u52A1\u5728\u4F60\u5F53\u524D\u6D4F\u89C8\u5668\u4E2D\u65E0\u6CD5\u4F7F\u7528\uFF0C\u5EFA\u8BAE\u4F60\u66F4\u6362\u4E3A\u6700\u65B0\u7248\u672C Chrome / Firefox / Edge \u6D4F\u89C8\u5668\u67E5\u770B\u672C\u7F51\u7AD9\u3002",
    style: {
      top: 0,
      left: 0,
      height: 56,
      width: '100%',
      position: 'fixed',
      zIndex: Number.MAX_SAFE_INTEGER
    },
    action: /*#__PURE__*/React.createElement(Button, {
      type: "link",
      onClick: function onClick() {
        return window.open('https://browsehappy.com/');
      }
    }, "\u67E5\u770B\u8BE6\u60C5")
  }), /*#__PURE__*/React.createElement(StyleProvider, {
    hashPriority: "high",
    transformers: [legacyLogicalPropertiesTransformer]
  }, properties.children));
};